import { Navigate, useLocation } from "react-router-dom";

import { useAuth } from "@/context/AuthContext";
import { hasRequiredRole, isKnownUiRole, hasRecruitmentProfile } from "@/lib/adminRoles";
import { canAccessRoute, getRoleHomePath } from "@/lib/navigation";
import AccessDenied from "@/pages/admin/AccessDenied";

const RequireRole = ({ children, roles = [], fullScreen = false }) => {
  const { authInitialized, isAuthenticated, role, user } = useAuth();
  const location = useLocation();

  if (!authInitialized) {
    return (
      <div
        className={`${fullScreen ? "min-h-screen bg-lenvia-bg" : "min-h-[40vh]"} flex items-center justify-center`}
      >
        <div className="h-8 w-8 rounded-full border-2 border-lenvia-blue border-t-transparent animate-spin" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/admin/login" replace state={{ from: location, sessionExpired: true }} />;
  }

  if (location.pathname.startsWith('/admin/recrutement/') && hasRecruitmentProfile(user) && (roles.length === 0 || roles.includes('RH'))) return children;

  if (roles.length > 0 && !hasRequiredRole(role, roles)) {
    if (!isKnownUiRole(role)) {
      return <AccessDenied fullScreen={fullScreen} />;
    }

    if (location.pathname.startsWith("/admin") || location.pathname.startsWith("/collab")) {
      return <Navigate to={getRoleHomePath(role)} replace />;
    }

    return <AccessDenied fullScreen={fullScreen} />;
  }

  if (
    roles.length === 0 &&
    canAccessRoute(role, location.pathname) === false &&
    location.pathname !== "/admin"
  ) {
    if (!isKnownUiRole(role)) {
      return <AccessDenied fullScreen={fullScreen} />;
    }

    return <Navigate to={getRoleHomePath(role)} replace />;
  }

  return children;
};

export default RequireRole;
